/**
 * Entidad StoreBanner
 * Banners para la portada de la web de la tienda
 */

import { Media } from "../common";

export interface StoreBanner {
  id: string;
  accountId: string;
  title: string;
  desktopMediaId: string;
  mobileMediaId?: string | null;
  linkUrl?: string | null;
  altText?: string | null;
  displayOrder: number;
  startDate?: Date | null;
  endDate?: Date | null;
  status: StoreBannerStatus;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;

  // Relationships
  desktopMedia?: Partial<Media> | null;
  mobileMedia?: Partial<Media> | null;
}

export enum StoreBannerStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE"
}

 